import { gql, TypedDocumentNode } from '@common/hooks';
import { HistoryInfoFragment } from '@common/graphql';
import {
  WorkerScheduleCodeQueryCgResponse,
  WorkerScheduleCodeQueryVariables,
  WorkerScheduleCodesQueryCgResponse,
  WorkerScheduleCodesQueryVariables,
} from '@common/graphql/schema';

export type WorkerScheduleCodeType =
  WorkerScheduleCodesQueryCgResponse['workerScheduleCodes'][number];

export const WORKER_SCHEDULE_CODES_QUERY: TypedDocumentNode<
  WorkerScheduleCodesQueryCgResponse,
  WorkerScheduleCodesQueryVariables
> = gql`
  query WorkerScheduleCodes {
    workerScheduleCodes {
      id
      code
      displayName
      description
      sourceType
      fteContributing
      fatigueContributing
      constraintType
      ingest
      incentive
      standby
      excusedAbsence
      createdAt
      lastEditedAt
      lastEditedBy
    }
    schedulingLoadBalancingEnabled
    moneyPayCodesEnabled
  }
`;

export const WORKER_SCHEDULE_CODE_QUERY: TypedDocumentNode<
  WorkerScheduleCodeQueryCgResponse,
  WorkerScheduleCodeQueryVariables
> = gql`
  query WorkerScheduleCode($id: ID!) {
    workerScheduleCode(id: $id) {
      id
      code
      displayName
      description
      sourceType
      fteContributing
      fatigueContributing
      constraintType
      incentive
      history {
        ...HistoryInfoFragment
      }
    }
    schedulingLoadBalancingEnabled
    moneyPayCodesEnabled
  }
  ${HistoryInfoFragment}
`;
